import { useState } from "react";
import {
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
	Collapse,
	Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ExpandLess, ExpandMore, Add } from "@mui/icons-material";
import AddWalletModal from "./Modals/AddWalletModal";
import WalletsList from "./WalletsList";
import { useTodayNetWorthQuery } from "../../../../services/queryHooks";
import { useTranslation } from "react-i18next";

export default function WalletTile({ title, type, wallets }) {
	const theme = useTheme();
	const { t } = useTranslation();
	const [isExpanded, setIsExpanded] = useState(true);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const userCurrency = localStorage.getItem("userCurrency");

	const { data: todayNetWorthData, isLoading: isPending } =
		useTodayNetWorthQuery();

	const getTotalValue = () => {
		if (!todayNetWorthData) return 0;

		if (type === "cash") {
			return todayNetWorthData.assets?.Cash ?? 0;
		} else if (type === "asset") {
			const { Cash, ...otherAssets } = todayNetWorthData.assets || {};
			return Object.values(otherAssets).reduce(
				(acc, val) => acc + val,
				0
			);
		} else if (type === "liability") {
			return Object.values(todayNetWorthData.liabilities || {}).reduce(
				(acc, val) => acc + val,
				0
			);
		}
		return 0;
	};

	return (
		<>
			<List
				sx={{
					flexGrow: 1,
					backgroundColor: theme.palette.background.paper,
					borderRadius: "10px",
				}}
			>
				<ListItem sx={{ pt: 0, pb: 0 }}>
					<ListItemText>
						<Typography
							variant="h6"
							gutterBottom
							sx={{ marginBottom: 0 }}
						>
							{title}
						</Typography>
					</ListItemText>
					<ListItemText sx={{ textAlign: "right" }}>
						<Typography
							variant="h6"
							gutterBottom
							sx={{ marginBottom: 0 }}
						>
							{isPending
								? t("loading")
								: `${getTotalValue().toFixed(2).toLocaleString()} ${userCurrency}`}
						</Typography>
					</ListItemText>
					<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
						<Add
							sx={{ cursor: "pointer" }}
							onClick={() => setIsAddModalOpen(true)}
						/>
					</ListItemIcon>
					{wallets.length > 0 && (
						<ListItemIcon sx={{ minWidth: "auto", ml: 1 }}>
							{isExpanded ? (
								<ExpandLess
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							) : (
								<ExpandMore
									sx={{ cursor: "pointer" }}
									onClick={() => setIsExpanded(!isExpanded)}
								/>
							)}
						</ListItemIcon>
					)}
				</ListItem>
				{wallets.length === 0 && (
					<ListItem>
						<ListItemText>
							<Typography variant="body2" color="textSecondary">
								{t("noWalletsFound")}
							</Typography>
						</ListItemText>
					</ListItem>
				)}
				<Collapse in={isExpanded}>
					<WalletsList type={type} wallets={wallets} />
				</Collapse>
			</List>
			<AddWalletModal
				isOpen={isAddModalOpen}
				onClose={() => setIsAddModalOpen(false)}
				type={type}
			/>
		</>
	);
}
